import { call, put } from 'redux-saga/effects';

import {
  setCategories,
  setFeaturedBlog,
  setIsLoading,
  setLoadMoreState,
  setPosts,
  setTotalPosts,
} from '../actions/resourcesActions';
import Services from '../services';

export function* loadResourcesPosts(action) {
  yield put(setIsLoading(true));
  yield put(setLoadMoreState(false));
  try {
    const response = yield call(
      Services.ResourcesService.getResourcesPosts,
      action.page,
      action.limit,
      action.order,
      action.category,
    );
    yield put(setPosts(response.data));
    yield put(setTotalPosts(response.totalPages));
    yield put(setIsLoading(false));
    if (response.totalPages > action.page) {
      yield put(setLoadMoreState(true));
    }
  } catch (exception) {
    // alert(exception);
  }
}

export function* loadPostCategories(action) {
  try {
    const response = yield call(Services.ResourcesService.getPostCategories);
    yield put(setCategories(response));
  } catch (exception) {
    // alert(exception);
  }
}

export function* loadFeaturedBlog(action) {
  try {
    const response = yield call(Services.ResourcesService.getFeaturedBlog);
    yield put(setFeaturedBlog(response));
  } catch (exception) {
    // alert(exception);
  }
}
